(function () {
  function initCollectionFaq(root) {
    const section = root.matches('[data-collection-faq]') ? root : root.querySelector('[data-collection-faq]');
    if (!section || section.dataset.faqBound === 'true') return;

    section.dataset.faqBound = 'true';

    section.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-collection-faq-toggle]');
      if (!toggle) return;

      const item = toggle.closest('[data-collection-faq-item]');
      if (!item) return;

      const isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));

      const icon = toggle.querySelector('[data-collection-faq-icon]');
      if (icon) {
        icon.textContent = isOpen ? '+' : '–';
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-collection-faq]').forEach(initCollectionFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-collection-faq]');
    if (section) {
      delete section.dataset.faqBound;
      initCollectionFaq(section);
    }
  });
})();
